import label from './pie.data.emphasis.label'
import labelLine from './pie.data.emphasis.labelLine'
import itemStyle from './pie.data.emphasis.itemStyle'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "emphasis",
  type: "object",
  props: {
    label,
    labelLine,
    itemStyle,
  },
}
